import { useEffect } from "react";
import { Link, useParams } from "react-router";
import { PropertyId } from "@townsy/contracts";
import { useTownStore } from "../../state/store";

/**
 * Child of the town layout: `/` (nothing selected) and `/place/:id` (panel open and focused).
 * Selection is route-driven so links, back/forward and scene clicks all agree.
 */
export function TownView() {
  const { id } = useParams<{ id: string }>();
  const valid = id ? PropertyId.safeParse(id).success : false;
  const selectProperty = useTownStore((s) => s.selectProperty);
  const name = useTownStore((s) => {
    const p = id ? s.properties[id] : undefined;
    return p ? (p.placement?.businessName ?? p.civic?.name ?? p.address) : null;
  });

  useEffect(() => {
    selectProperty(valid && id ? id : null);
    return () => selectProperty(null);
  }, [id, valid, selectProperty]);

  useEffect(() => {
    document.title = id && valid ? `${name ?? id} · Townsy` : "Townsy";
  }, [id, valid, name]);

  if (id && !valid) {
    return (
      <section className="panel panel-right" role="region" aria-label="Unknown place">
        <div className="panel-header">
          <h2>No such place</h2>
          <Link className="btn btn-ghost icon-btn" to="/" aria-label="Close">
            ×
          </Link>
        </div>
        <div className="panel-body">
          <p>
            <code>{id}</code> is not a Townsy address. Try the <Link to="/directory">directory</Link>.
          </p>
        </div>
      </section>
    );
  }
  return null;
}
